import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppProviders } from './AppProviders';
import { App } from './App';
import { initSentry } from './shared/lib/sentry';
import './i18n';
import './globals.css';

// Initialize Sentry error tracking
initSentry();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find the root element');
}

createRoot(rootElement).render(
  <StrictMode>
    <AppProviders router={<BrowserRouter><App /></BrowserRouter>} />
  </StrictMode>
);
